<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <div class="d-flex justify-content-between">
        <div class="header-tablepage">สินค้า</div>
        <InputText
          v-model="filter.search"
          type="text"
          faIcon="search"
          className="mb-2 bg-second w-50"
          placeholder="ค้นหาชื่อ, บาร์โคด"
          @onClickIcon="handleSearch"
          @onEnter="handleSearch"
        />
      </div>
      <b-table
        responsive
        striped
        hover
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="No matching records found"
        class="table-main"
        :sort-by.sync="filter.sortBy"
        :sort-desc.sync="filter.sortDesc"
        no-local-sorting
        @sort-changed="storeSorting"
      >
        <template v-slot:cell(image_url)="{ item }">
          <img :src="item.image_url" class="img-size" v-if="item.image_url" />
          <img
            v-else
            src="@/assets/images/noimg.png"
            alt="no-image-product"
            class="img-size"
          />
        </template>
        <template v-slot:cell(name)="{ item }">
          <div
            class="text-link"
            @click="$router.push(`/product/detail/${item.product_id}`)"
          >
            {{ item.name }}
          </div>
          <span class="text-gray">{{ item.barcode }}</span>
        </template>
        <template v-slot:cell(price)="{ item }">
          {{ item.price | numeral("0,0.00") }}
        </template>
        <template v-slot:cell(status)="{ item }">
          <div
            :class="{
              'text-success': item.status,
              'text-danger': !item.status,
            }"
          >
            {{ item.status ? "เปิดใช้งาน" : "ไม่เปิดใช้งาน" }}
          </div>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTake"
        :pageOptions="pageOptions"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />
    </div>
  </div>
</template>
<script>
import OtherLoading from "@/components/loading/OtherLoading";
import { mapGetters } from "vuex";
export default {
  components: {
    OtherLoading,
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  name: "Product",
  data() {
    return {
      isLoading: false,
      filter: {
        search: "",
        page: 1,
        take: 10,
        branch_id: "",
        sortBy: "",
        sortDesc: false,
        SortColumnId: 0,
        SortType: true,
      },
      items: [],
      isBusy: false,
      rows: 0,
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      fields: [
        {
          key: "image_url",
          label: "รูป",
        },
        {
          key: "name",
          label: "Name / Code / Type ",
          class: "text-left",
          thClass: "w-100px",
          id: 1,
        },
        {
          key: "ah_no",
          label: "AH ",

          thClass: "w-100px",
          id: 1,
        },
        {
          key: "barcode",
          label: "Barcode",
          thClass: "w-100px",
          id: 5,
          sortable: true,
        },
        {
          key: "price",
          label: "ราคา ",
          thClass: "w-100px",
          id: 2,
        },
      ],
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoading = true;
      this.isBusy = true;
      this.filter.branch_id = this.branchId;
      const res = await this.axios.post(
        `${this.$baseUrl}/product/get_branch_product_stock`,
        this.filter
      );
      if (res.result == 1) {
        await this.$store.dispatch("getDynamicFields", {
          products_id: res.detail.branch_product_stock_list.map(
            (el) => el.product_id
          ),
          body: res.detail.branch_product_stock_list,
          serials_id: [],
          fields: this.fields,
        });
        this.fields.push(
          {
            key: "stock",
            label: "จำนวน",
            thClass: "w-1",
          },
          {
            key: "status",
            label: "สถานะ",
            thClass: "w-1",
          }
        );
        console.log(this.fields);
        this.isLoading = false;
        this.items = res.detail.branch_product_stock_list;
        this.rows = res.detail.count;
      }

      this.isBusy = false;
    },
    async handleSearch() {
      this.filter.page = 1;
      await this.getList();
    },
    pagination(page) {
      this.filter.page = page;

      this.getList();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;

      this.getList();
    },
    storeSorting(ctx) {
      if (this.filter.sortBy === ctx.sortBy && !ctx.sortDesc) {
        this.filter.sortBy = "";
        this.filter.sortDesc = "";
        this.filter.SortColumnId = 0;
        this.filter.SortType = true;
      } else {
        this.filter.SortColumnId = 0;
        this.filter.SortType = ctx.sortDesc;
        this.filter.sortBy = ctx.sortBy;
        this.filter.sortDesc = ctx.sortDesc;
      }

      this.getList();
    },
  },
};
</script>
